module.exports = __webpack_public_path__ + "img/dep_medicineandfirstaid@2x.5842babb.png";